var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDendrogram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 6H38.4864C35.0091 6 29.5625 7.77081 25.2836 14.6594C20.4425 22.4529 18.9972 24.3673 9 23.9452",
    stroke: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 42H38.4864C35.0091 42 29.5625 40.2292 25.2836 33.3406C20.4425 25.5471 18.9972 23.6327 9 24.0548",
    stroke: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8232 36C40.5095 36 37.8621 38.686 37.9101 41.9994C37.9581 45.3128 40.6834 47.9988 43.9971 47.9988C47.3108 47.9988 49.9581 45.3128 49.9101 41.9994C49.8621 38.686 47.1369 36 43.8232 36Z",
    fill: "#3B82C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8232 -2.18867e-05C40.5095 -2.1597e-05 37.8621 2.68599 37.9101 5.99935C37.9581 9.31271 40.6834 11.9987 43.9971 11.9987C47.3108 11.9987 49.9581 9.31271 49.9101 5.99935C49.8621 2.68599 47.1369 -2.21764e-05 43.8232 -2.18867e-05Z",
    fill: "#3B82C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00003 24H44",
    stroke: "#B3B3B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000282502 24.0001C0.000282357 20.6864 2.68629 18.039 5.99965 18.087C9.31301 18.135 11.999 20.8602 11.999 24.1739C11.999 27.4877 9.31301 30.135 5.99965 30.087C2.68629 30.039 0.000282647 27.3138 0.000282502 24.0001Z",
    fill: "#2B6299"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9958 24C49.9958 20.6863 47.3098 18.0389 43.9964 18.0869C40.6831 18.1349 37.9971 20.8601 37.9971 24.1738C37.9971 27.4875 40.6831 30.1349 43.9964 30.0869C47.3098 30.0389 49.9958 27.3137 49.9958 24Z",
    fill: "#8CBFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDendrogram);
export default __webpack_public_path__ + "static/media/dendrogram.7bae499b.svg";
export { ForwardRef as ReactComponent };